import {genqlBuilder} from "@/core/graphql/genql/builder"

import {MutationGenqlSelection, PushUnsubscribeResult} from "../schema"

export type MutationPushUnsubscribeVars = {}

export function pushUnsubscribeMutation(mutation: MutationGenqlSelection['push_unsubscribe'] | null) {            
    return {
      build: (variables: MutationPushUnsubscribeVars) => genqlBuilder.build(mutation ? {push_unsubscribe: mutation} : {__scalar: true}, {push_unsubscribe: variables}),  
      mutate: (variables: MutationPushUnsubscribeVars) => ({} as Promise<PushUnsubscribeResult>),
      _variables: {} as MutationPushUnsubscribeVars,
      _result: {} as PushUnsubscribeResult,
    }
}

export type MutationPushUnsubscribe = {
  builder: (variables: MutationPushUnsubscribeVars) => MutationGenqlSelection,
  selection: MutationGenqlSelection['push_unsubscribe'],
  variables: MutationPushUnsubscribeVars,
  result: PushUnsubscribeResult
}

export default pushUnsubscribeMutation